import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient, getAuthService, getHttpClient } from '@edx/frontend-platform/auth';
import { getLocale } from '@edx/frontend-platform/i18n';
import * as QueryString from 'query-string';

export async function registerRequest(registrationInformation) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    isPublic: true,
  };

  const { data } = await getAuthenticatedHttpClient()
    .post(
      `${getConfig().LMS_BASE_URL}/api/user/v2/account/registration/`,
      QueryString.stringify(registrationInformation),
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });

  return {
    redirectUrl: data.redirect_url || `${getConfig().LMS_BASE_URL}/dashboard`,
    success: data.success || false,
    authenticatedUser: data.authenticated_user,
  };
}

export async function getFieldsValidations(formPayload) {
  const locale = getLocale();
  const requestConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept-Language': locale,
    },
  };

  const { data } = await getHttpClient()
    .post(
      `${getConfig().LMS_BASE_URL}/api/user/v1/validation/registration`,
      QueryString.stringify(formPayload),
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });

  return {
    fieldValidations: data,
  };
}

export async function getMarketingPreference() {
  try {
    // Clear and get fresh CSRF token
    const authService = getAuthService();
    if (authService) {
      authService.getCsrfTokenService().clearCsrfTokenCache();
      await authService.getCsrfTokenService().getCsrfToken(getConfig().LMS_BASE_URL);
    }

    const requestConfig = {
      headers: {
        Accept: 'application/json',
      },
    };

    const { data } = await getAuthenticatedHttpClient()
      .get(
        `${getConfig().LMS_BASE_URL}/campus_api_extensions/user_attributes_is_marketable/`,
        requestConfig,
      )
      .catch((e) => {
        throw (e);
      });

    return data;
  } catch (error) {
    console.error('Error getting marketing preference:', error);
    throw error;
  }
}

export async function updateMarketingPreference(isMarketable) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/json' },
  };

  const authService = getAuthService();

  if (authService) {
    authService.getCsrfTokenService().clearCsrfTokenCache();
    await authService.getCsrfTokenService().getCsrfToken(getConfig().LMS_BASE_URL);
  }

  const data = {
    is_marketable: isMarketable,
  };

  const { data: responseData } = await getAuthenticatedHttpClient()
    .post(
      `${getConfig().LMS_BASE_URL}/campus_api_extensions/user_attributes_is_marketable/`,
      data,
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });

  return responseData;
}
